export const buildFullName = (lastName: string, firstName: string, middleName?: string | null): string =>
    `${lastName} ${firstName}${middleName ? ` ${middleName}` : ``}`;

export const buildInnKpp = (inn: string, kpp?: string | null): string => `${inn}${kpp ? `—${kpp}` : ``}`;
